import { render, staticRenderFns } from "./AddPenalty.vue?vue&type=template&id=6d2c4c90"
import script from "./AddPenalty.vue?vue&type=script&lang=js"
export * from "./AddPenalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports